var flyout = document.getElementById("newsletterFlyout");
if (flyout) {
    var form = document.getElementById("newsletterForm");
    var statusEl = document.getElementById("newsletterStatus");
    var closeBtn = flyout.querySelector(".newsletter-flyout__close");
    function hide() {
        flyout.classList.remove("is-visible");
        sessionStorage.setItem("homez_newsletter_closed", "1");
    }
    setTimeout(function() {
        if (!sessionStorage.getItem("homez_newsletter_closed")) flyout.classList.add("is-visible");
    }, 4000);
    if (closeBtn) closeBtn.addEventListener("click", hide);
    if (form) form.addEventListener("submit", function(e) {
        e.preventDefault();
        var email = (form.email && form.email.value || "").trim();
        if (statusEl) {
            if (!email) {
                statusEl.textContent = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 email.";
                return;
            }
            statusEl.textContent = "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u044B \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u044B.";
            statusEl.style.color = "green";
        }
        form.reset();
        setTimeout(hide, 1500);
    });
}

//# sourceMappingURL=public.81c98f97.js.map
